import { render } from "./form-flat.vue?vue&type=template&id=4e487acd&scoped=true"
import script from "./form-flat.vue?vue&type=script&lang=js"
export * from "./form-flat.vue?vue&type=script&lang=js"

import "./form-flat.vue?vue&type=style&index=0&id=4e487acd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e487acd"]])

export default __exports__